import { render, staticRenderFns } from "./BonusSelector.vue?vue&type=template&id=0578b53c&"
import script from "./BonusSelector.vue?vue&type=script&lang=js&"
export * from "./BonusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports